// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"915":"0c8c574d1ca784cc","4028":"e3f918fc1af7f5e2"}[chunkId] + ".css";
};